import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";

export { default as Button } from "./Button.vue";

export const buttonVariants = cva(
  "inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md text-content uppercase ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    defaultVariants: {
      size: "default",
      variant: "outline",
    },
    variants: {
      size: {
        default: "h-9 min-w-[110px] px-4 py-2",
        icon: "h-9 w-9",
        input: "h-9 max-h-9 min-h-9 min-w-[110px] px-3 py-2",
        lg: "h-10 min-w-[110px] rounded-md px-16",
        sm: "text-xs h-8 min-w-[110px] rounded-md px-6",
      },
      variant: {
        default: "justify-center bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive:
          "justify-center bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        ghost: "justify-center hover:bg-accent hover:text-accent-foreground",
        input:
          "flex w-full rounded-md border border-input bg-background text-content file:border-0 file:bg-transparent file:text-content file:font-medium placeholder:text-content placeholder:text-muted-foreground focus-visible:outline-none",
        link: "justify-center text-primary underline-offset-4 hover:underline",
        outline:
          "justify-center border border-input shadow-sm hover:bg-primary hover:text-primary-foreground",
        secondary:
          "justify-center bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
      },
    },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
